import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import {
    Box,
    Container,
    Grid,
    CircularProgress,
    Typography,
} from '@mui/material';
import Header from '../../../src/components/Header';
import Footer from '../../../src/components/Footer';
import CertImg from './CertImg';
import CertDetails from './CertDetails';
import SocialShare from './SocialShare';
import { verifyCertificate } from '../../services/certificateService';

function ViewCert() {
    const { certId } = useParams();
    const [certificate, setCertificate] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCertificate = async () => {
            const response = await verifyCertificate(certId);
            if (response.success) {
                setCertificate(response.certificate);
            }
            setLoading(false);
        };

        fetchCertificate();
    }, [certId]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                backgroundColor: '#f5f5f5',
            }}
        >
            <Header />

            <Container maxWidth="lg" sx={{ flexGrow: 1, py: { xs: 3, md: 5 } }}>
                {loading ? (
                    <Box sx={{ textAlign: 'center', mt: '4rem' }}>
                        <CircularProgress />
                    </Box>
                ) : certificate ? (
                    <>
                        {/* Certificate Image + Social Media Row */}
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={8}>
                                <CertImg imageUrl={certificate.imageUrl} />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <SocialShare csnId={certificate.csnId} />
                            </Grid>
                        </Grid>

                        {/* Certificate Details */}
                        <Box mt={4}>
                            <CertDetails certificate={certificate} />
                        </Box>
                    </>
                ) : (
                    <Box
                        sx={{
                            flexGrow: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            py: { xs: 6, md: 8 },
                            px: 2,
                            textAlign: 'center',
                        }}
                    >
                        <Typography variant="h4" fontWeight="600" gutterBottom>
                            Certificate Not Found
                        </Typography>

                        <Grid container justifyContent="center" sx={{ mb: 3 }}>
                            <Grid item xs={12} md={6}>
                                <Typography variant="body1" color="text.secondary">
                                    We couldn't find any certificate with the ID <strong>{certId}</strong>. Please double-check the certificate ID or try verifying again.
                                </Typography>
                            </Grid>
                        </Grid>

                        <Box
                            component={Link}
                            to="/certificate/verify"
                            sx={{
                                display: 'inline-block',
                                textDecoration: 'none',
                                px: 3,
                                py: 1.2,
                                borderRadius: 2,
                                border: '2px solid #2F96FF',
                                color: '#2F96FF',
                                fontWeight: 600,
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    backgroundColor: '#2F96FF0A',
                                },
                            }}
                        >
                            Go Back to Verification
                        </Box>
                    </Box>
                )}
            </Container>

            <Footer />
        </Box>
    );
}

export default ViewCert;
